export default __webpack_public_path__ + "static/media/live.d112e8ad.svg";